import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart, FaBars, FaTimes } from 'react-icons/fa';
import styles from './Navbar.module.css';
import logo from '../../assets/images/logo-dark.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav className={`${styles.navbar} ${isScrolled ? styles.scrolled : ''}`}>
        <Link to="/" className={styles.logo} onClick={() => setIsMenuOpen(false)}>
          <img src={logo} alt="Company Logo" />
        </Link>
        
        <button 
          className={styles.menuToggle} 
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
        
        <ul className={`${styles.navList} ${isMenuOpen ? styles.active : ''}`}>
          <li className={styles.navItem}>
            <Link to="/about" onClick={() => setIsMenuOpen(false)}>About</Link>
          </li>
          <li className={styles.navItem}>
            <Link to="/services" onClick={() => setIsMenuOpen(false)}>
              Services<span className={styles.plus}>+</span>
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link to="/industries" onClick={() => setIsMenuOpen(false)}>
              Industries<span className={styles.plus}>+</span>
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link to="/packages" onClick={() => setIsMenuOpen(false)}>
              Packages<span className={styles.plus}>+</span>
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link to="/blog" onClick={() => setIsMenuOpen(false)}>Blog</Link>
          </li>
          <li className={styles.navItem}>
            <div className={styles.over}>
              <Link to="/cart" aria-label="Shopping cart">
                <FaShoppingCart className={styles.shop} />
              </Link>
              <button className={styles.btns}>Request A Quote</button>
            </div>
          </li>
        </ul>
      </nav>
      <div className={styles.mainContent}>
       
      </div>
    </>
  );
};

export default Navbar;